import { useMemo } from "react";

import {
  getProjectPageTheme,
  type ProjectPageTheme
} from "@/helpers/project-page-theme";
import { useAppSelector } from "@/redux/store/hooks";

const useProjectPageTheme = (): ProjectPageTheme => {
  const selectedColorPalette = useAppSelector(
    (state) => state.layout?.layout?.selectedColorPalette
  );
  const colorMapping = useAppSelector(
    (state) => state.layout?.layout?.colorMapping
  );
  const siteTheme = useAppSelector((state) => state.theme?.theme);

  return useMemo(
    () =>
      getProjectPageTheme(selectedColorPalette, null, colorMapping, siteTheme),
    [selectedColorPalette, colorMapping, siteTheme]
  );
};

export default useProjectPageTheme;
